import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AbsencesContext = createContext(null);

export function AbsencesProvider({ children }) {
  const [absences, setAbsences] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/absences`);
      setAbsences(res.data || []);
      return res.data || [];
    } catch (e) {
      console.error("Failed to load absences", e);
      return [];
    }
  }, []);

  useEffect(() => {
    (async () => {
      await refresh();
      setLoading(false);
    })();
  }, [refresh]);

  const listByClassDate = useCallback(async (klasId, date) => {
    const res = await axios.get(`${API}/absences`, { params: { klasId, date } });
    return res.data || [];
  }, []);

  const saveClassDate = useCallback(async (klasId, date, talmidIds) => {
    const res = await axios.post(`${API}/absences/bulk`, { klasId, date, talmidIds });
    await refresh();
    return res.data;
  }, [refresh]);

  return (
    <AbsencesContext.Provider value={{ absences, loading, refresh, listByClassDate, saveClassDate }}>
      {children}
    </AbsencesContext.Provider>
  );
}

export function useAbsences() {
  const ctx = useContext(AbsencesContext);
  if (!ctx) throw new Error("useAbsences must be used within AbsencesProvider");
  return ctx;
}
